(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/distribution-display.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/distribution-display.js');
"use strict";

const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const buttonChoices = svs.components.sport.tipsenShared.buttonChoices;
const getProductDistribution = svs.components.tipsen.couponStatic.utils.getProductDistribution;
const useBetEvent = svs.components.sportinfo.matchInfoHooks.useBetEvent;
const DistributionDisplay = _ref => {
  let distributionChoice = _ref.distributionChoice,
    eventNumber = _ref.eventNumber,
    drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    selectedCouponChoice = _ref.selectedCouponChoice;
  const _useBetEvent = useBetEvent({
      productId,
      drawNumber,
      eventNumber
    }),
    betEvent = _useBetEvent.betEvent,
    eventStatistics = _useBetEvent.eventStatistics;
  const isGoalCount = (betEvent === null || betEvent === void 0 ? void 0 : betEvent.eventTypeId) === EventTypeId.GOAL_COUNT;
  const productDistribution = getProductDistribution({
    eventStatistics,
    productId,
    drawNumber
  });
  return React.createElement("div", {
    className: "pg_coupon_static__event_distribution ".concat(isGoalCount ? 'fc-fulltraff-400' : '')
  }, selectedCouponChoice === buttonChoices.SYSTEM_DISTRIBUTION && distributionChoice[eventNumber - 1].map((outcome, i) => {
    const key = "".concat(i, "_").concat(outcome);
    return React.createElement("span", {
      className: "pg_coupon_static__event_distribution__text",
      key: key
    }, outcome);
  }), selectedCouponChoice === buttonChoices.PEOPLE_DISTRIBUTION && productDistribution.current.value.map((outcome, i) => {
    const key = "".concat(i, "_").concat(outcome);
    return React.createElement("span", {
      className: "pg_coupon_static__event_desc_text",
      key: key
    }, outcome);
  }));
};
setGlobal('svs.components.tipsen.couponStatic.DistributionDisplay', DistributionDisplay);

 })(window);